import PropTypes from "prop-types"

import SimpleLineChart from "../simple_line_chart.js"
import brandMetricsFetcher from "./brand_metrics_fetcher"
import PeriodSelectionHOC from "../period_selection_hoc"
import { reduceSeriesToValue, computeChangeThisPeriod } from "../lib"

import "../stats.scss"

const BrandComponent = ({ data, timePeriodInDays, serviceName }) => (
  <div styleName="stats-container brand">
    <div styleName="grouped-charts">
      <SimpleLineChart
        chartTitle={`Applet views`}
        data={data}
        currentValue={reduceSeriesToValue(
          data,
          timePeriodInDays,
          "applet_views_daily"
        )}
        changeRate={computeChangeThisPeriod(
          data,
          timePeriodInDays,
          "applet_views_daily"
        )}
        metric={"applet_views_daily"}
        units={"views"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of Applet views in the last ${timePeriodInDays} days where ${serviceName} is a trigger or action`}
      />
      <SimpleLineChart
        chartTitle={"Service page views"}
        data={data}
        currentValue={reduceSeriesToValue(
          data,
          timePeriodInDays,
          "service_page_views_daily"
        )}
        changeRate={computeChangeThisPeriod(
          data,
          timePeriodInDays,
          "service_page_views_daily"
        )}
        metric={"service_page_views_daily"}
        units={"views"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of service page views for ${serviceName} in the last ${timePeriodInDays} days`}
      />
    </div>
  </div>
)

BrandComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  timePeriodInDays: PropTypes.number,
  serviceName: PropTypes.string,
}

export default PeriodSelectionHOC({
  WrappedComponent: BrandComponent,
  serviceMetricsFetcher: brandMetricsFetcher,
  headerText: "Brand impressions",
})
